import {QuadrangleVertex} from '../../abstract-units';
import {BoxEdge} from '../../edge';
import {CellAreaDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';
import {BOTTOM_EDGE_CELL_AREA_DEF} from './bottom-edge';
import {CENTER_CELL_AREA_DEF} from './center';
import {TOP_EDGE_CELL_AREA_DEF} from './top-edge';

export const LEFT_SIDE_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.SIDE,
    boxEdge: BoxEdge.LEFT,
    vertices: [
        TOP_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_LEFT], // TOP_LEFT
        CENTER_CELL_AREA_DEF.vertices[QuadrangleVertex.TOP_LEFT], // TOP_RIGHT
        BOTTOM_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.TOP_LEFT], // BOTTOM_LEFT
        CENTER_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_LEFT] // BOTTOM_RIGHT
    ]
};
